__turbopack_context__.v({
  "achievementBadge": "_Y0iaG_achievementBadge",
  "achievementBadgeButton": "_Y0iaG_achievementBadgeButton",
});
